<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Add Notice</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("notice.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="notice.title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="notice.description"
                    name="description"
                    label="Description"
                    v-validate="'required'"
                    rows="2"
                    :error="
                      errors.first('description') != null ||
                      serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                      serverSideErrors.description
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="notice.expiry_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="notice.expiry_date"
                        label="Expiry Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on" 
                        id="ExpiryDate"
                        name="ExpiryDate"
                        clearable
                        v-validate="''"
                        :error="
                          errors.first('ExpiryDate') != null ||
                          serverSideErrors.expiry_date != null
                        "
                        :error-messages="
                          errors.first('ExpiryDate') ||
                          serverSideErrors.expiry_date
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="notice.expiry_date"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(notice.expiry_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-file-input
                    v-model="notice.documents"
                    label="Notice Document"
                    prepend-icon="mdi-camera"
                    multiple
                    :error="serverSideErrors.documents != null"
                    :error-messages="serverSideErrors.documents"
                    hint="Only jpg, png, gif, pdf, jpeg, svg file types are allowed"
                    persistent-hint
                    ><template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template></v-file-input
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveNoticeDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      member: {},
      serverSideErrors: {},
      notice: {
        title: "",
        description: "",
        picture: [],
        expiry_date: '',
      },
      menu: false,
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    saveNoticeDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.notice.title);
          formData.append("description", this.notice.description);
          formData.append("picture", this.notice.picture);
          formData.append("expiry_date", this.notice.expiry_date ? moment.utc(this.notice.expiry_date).valueOf() : "");
          if (this.notice.documents) {
            for (let i = 0; i < this.notice.documents.length; i++) {
              formData.append("documents[]", this.notice.documents[i]);
            }
          }

          _self.$axios
            .post("/societyadmin/notices/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push({ path: "/societyadmin/notice" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>